// AutoCompleteInput.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../constants/api';
// import { Spinner } from 'react-bootstrap'; // optional, for loading spinner

const AutoCompleteInput = ({
  col,
  value,
  onChange,
  placeholder = 'Search...',
}) => {
  const [displayValue, setDisplayValue] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  console.log('col:', col);
  const token = getToken();

  // Fetch suggestions from server
  const fetchSuggestions = async (query) => {
    if (query.trim().length < 3) {
      setSuggestions([]);
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete-v2/${col.id}?query=${encodeURIComponent(query)}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      setSuggestions(response.data.results || []);
    } catch (err) {
      console.error('Error fetching autocomplete suggestions:', err);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle input change with debounce
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setDisplayValue(newValue);

    // Debounce API calls
    if (timeoutId) clearTimeout(timeoutId);
    setTimeoutId(setTimeout(() => fetchSuggestions(newValue), 300));
  };

  // Handle selecting a suggestion
  const handleSelect = (item) => {
    setDisplayValue(item.name);
    setSuggestions([]);
    onChange(item.id, item.name, item.info); // Pass selection to parent form
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        type="text"
        className="form-control"
        value={displayValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        autoComplete="off"
      />

      {loading && (
        <div style={{ position: 'absolute', right: '10px', top: '8px' }}>
          {/* <Spinner animation="border" size="sm" /> */} Loading ..
        </div>
      )}

      {suggestions.length > 0 && (
        <ul
          className="list-group dropdown-menu show"
          style={{
            margin: 0,
            top: '100%',
            width: '100%',
            zIndex: 1,
            maxHeight: '200px', // Limit height
            overflowY: 'auto', // Add vertical scroll
            border: '1px solid #ccc', // Add border for better visibility
            borderRadius: '4px',
            backgroundColor: '#fff',
          }}
        >
          {suggestions.map((item) => (
            <li
              key={item.id}
              style={{
                padding: '8px',
                cursor: 'pointer',
              }}
              className="list-group-item"
              onClick={() => handleSelect(item)}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteInput;
